<template>
  <div>
    <div class="pa-5 bg-white">
      <v-tabs v-model="tab" grow>
        <v-tab :href="course" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Course Report</v-tab
        >
        <!-- <v-tab :href="live" class="subtitle-1 tab-live px-12 uppercast-unset">Live Report (Culi)</v-tab> -->
        <v-tab
          :href="live_report"
          class="subtitle-1 tab-live px-12 uppercast-unset"
          >Live Report</v-tab
        >
        <v-tab
          class="subtitle-1 tab-live px-12 uppercast-unset"
          :href="ondemand"
          >Ondemand Report</v-tab
        >
        <v-tab class="subtitle-1 tab-live px-12 uppercast-unset" :href="exam"
          >Exam Report</v-tab
        >
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab">
      <v-tab-item :value="course">
        <overview />
      </v-tab-item>
      <!-- <v-tab-item :value="live">
        <liveculi />
      </v-tab-item> -->
      <v-tab-item :value="live_report">
        <live />
      </v-tab-item>
      <v-tab-item :value="ondemand">
        <!--<live />-->
        <ondemand />
      </v-tab-item>
      <v-tab-item :value="examReport">
        <!--<live />-->
        <exam-report />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import overview from '@/views/course/report/overview.vue';
import ondemand from '@/views/course/report/ondemand.vue';
import liveculi from '@/views/course/report/live.vue';
import live from '@/views/course/report/liveReport.vue';
import examReport from '@/views/course/report/examReport.vue';
export default {
  components: {
    // liveculi,
    overview,
    ondemand,
    live,
    examReport,
  },
  data() {
    return {
      // current: 1,
      tab: 'course',
      id_course: null,
      learnerRequest: 0,
    };
  },
  methods: {
    init() {
      this.id_course = this.$route.query.id;

      if (this.$route.query.id) {
        this.tab = 0;
      }
    },
  },
};
</script>

<style scoped>
.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}

.v-tab--active {
  background: #fff !important;
  color: #009bde;
}

.bg-white {
  background: #fff;
}
</style>
